import { lazy, ComponentType } from 'react';
import { isInMobile } from '../utils/tool';

// 百科展示首页
const Dashboard = isInMobile ? lazy(() => import('../pages/m/Dashboard')) : lazy(() => import('../pages/Dashboard'));

// 百科详情
const PostPage = isInMobile ? lazy(() => import('../pages/m/PostPage')) : lazy(() => import('../pages/PostPage'));

// 百科日历
const CalendarPage = lazy(() => import('../pages/calendar/index'));

// 百科搜索结果

export interface IBasicMenu {
    path: string;
    title: string;
    component: React.LazyExoticComponent<ComponentType<any>>;
}

export const Menus: IBasicMenu[] = [
    {
        path: '/rili',
        title: 'rili',
        component: CalendarPage,
    },
    {
        path: '/calendar',
        title: 'calendar',
        component: CalendarPage,
    },
    {
        path: '/:code',
        title: 'post',
        component: PostPage,
    },
    {
        path: '/',
        title: 'dashboard',
        component: Dashboard,
    },
];
